module.exports = __webpack_public_path__ + "static/plomberie1-09227ea248b91f313fdbbfedddbafc14.jpg";